import React from 'react';
import { Box, Grid, Stack, Text, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { FormatCurrency } from '@css-xp/ppc-common';
import { NextBillEstimate } from '@css-xp/graphtypes/src/generated-types-new';
import { InlineDialog } from './next-invoice-estimate-tooltip.styles';

export const NextInvoiceEstimateTooltipContent = ({
  nextBillEstimate,
}: {
  nextBillEstimate?: NextBillEstimate | null;
}) => {
  return (
    <Box padding="space.150" testId="info-section-wrapper">
      <Stack space="space.075">
        <Stack
          xcss={xcss({
            marginBottom: 'space.100',
          })}
        >
          <Text weight="semibold">On your next bill</Text>
        </Stack>
        <Grid templateColumns="2fr 1fr" gap="space.200">
          <Text>Monthly renewal</Text>
          <Text>
            <FormatCurrency
              showCurrencyCode
              currency={nextBillEstimate?.currency}
              showCommas
              value={nextBillEstimate?.renewalCharge ?? 0}
            />
          </Text>
          <Text>Prorated cost based on usage charges</Text>
          <Text>
            <FormatCurrency
              showCurrencyCode
              currency={nextBillEstimate?.currency}
              showCommas
              value={nextBillEstimate?.proratedCharge ?? 0}
            />
          </Text>
          <Text weight="semibold">Estimated total</Text>
          <Text weight="semibold">
            <FormatCurrency
              showCurrencyCode
              currency={nextBillEstimate?.currency}
              showCommas
              value={nextBillEstimate?.total ?? 0}
            />
          </Text>
        </Grid>
        <Text size="small">
          Your final total includes any new users added up until your current billing cycle ends.
        </Text>
      </Stack>
    </Box>
  );
};

export const NextInvoiceEstimateTooltip = ({
  nextBillEstimate,
  children,
}: {
  nextBillEstimate?: NextBillEstimate | null;
  children: JSX.Element | JSX.Element[];
}) => {
  return (
    <Tooltip
      component={InlineDialog}
      content={<NextInvoiceEstimateTooltipContent nextBillEstimate={nextBillEstimate} />}
      position="bottom"
      tag="span"
      testId="next-invoice-estimate-tooltip"
    >
      {children}
    </Tooltip>
  );
};
